import * as React from 'react';
import { Component, inject, deps, observer } from '../../lib/component';

import {ButtonPill, ButtonPillProps} from '../button-pill';

export interface TypeformPopupButtonProps extends ButtonPillProps {
  typeformUrl: string;
}

@inject(deps) @observer
export class TypeformPopupButton extends Component<TypeformPopupButtonProps> {
  private popup: any;

  constructor(props: TypeformPopupButtonProps) {
    super(props);
    this.state = { ready: false };
  }

  render() {
    const { typeformUrl, ...props } = this.props;

    return (
      <ButtonPill {...props} onClick={this.showPopup}>{this.props.children}</ButtonPill>
    )
  }

  async componentDidMount() {
    const typeformEmbed = await import('@typeform/embed');
    this.popup = typeformEmbed.makePopup(this.props.typeformUrl, { mode: 'popup' });
  }

  showPopup = (event: React.MouseEvent<any>) => {
    if (!this.popup) return;

    this.popup.open();

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  static i18n = {};

  static styles = {};
}